import { render, staticRenderFns } from "./UserModelFilterNationalitySelectbox.vue?vue&type=template&id=efdbbd54&scoped=true"
import script from "./UserModelFilterNationalitySelectbox.vue?vue&type=script&lang=js"
export * from "./UserModelFilterNationalitySelectbox.vue?vue&type=script&lang=js"
import style0 from "./UserModelFilterNationalitySelectbox.vue?vue&type=style&index=0&id=efdbbd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdbbd54",
  null
  
)

export default component.exports